import { useState, useLayoutEffect, useRef, useCallback, useMemo } from "react"

export const useStateWithCallback = <T>(value: T) => {
  const callbackRef = useRef<(value: T) => void>(undefined)
  const [state, setState] = useState({ value })

  useLayoutEffect(() => {
    callbackRef.current?.(state.value)
    callbackRef.current = undefined
  }, [state])

  const setStateWithCallback = useCallback((value: T, callback: (value: T) => void) => {
    callbackRef.current = callback
    setState({ value })
  }, [])

  return useMemo(
    () => [state.value, setStateWithCallback] as const,
    [state.value, setStateWithCallback]
  )
}
